import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientDataTableItem } from 'src/app/services/clients/clients.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { NgTemplateOutlet, DecimalPipe } from '@angular/common';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeHorizontalLineComponent } from '../../../../shared/payee-horizontal-line/payee-horizontal-line.component';

export interface ConfirmMergeDialogData {
  masterClient: ClientDataTableItem;
  clientToMerge: ClientDataTableItem;
}

@Component({
  selector: 'app-confirm-merge-dialog',
  templateUrl: './confirm-merge-dialog.component.html',
  styleUrls: ['./confirm-merge-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    NgTemplateOutlet,
    PayeeButtonComponent,
    PayeeHorizontalLineComponent,
    DecimalPipe,
  ],
})
export class ConfirmMergeDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmMergeDialogComponent>>(MatDialogRef);
  data = inject<ConfirmMergeDialogData>(MAT_DIALOG_DATA);

  readonly duplicatePartners = new Set<string>();
  readonly duplicateUsers = new Set<string>();

  constructor() {
    for (const partnerA of this.data.clientToMerge.partners) {
      for (const partnerB of this.data.masterClient.partners) {
        if (partnerA.name === partnerB.name) {
          this.duplicatePartners.add(partnerA.name);
          break;
        }
      }
    }
    for (const userA of this.data.clientToMerge.users) {
      for (const userB of this.data.masterClient.users) {
        if (userA.email === userB.email) {
          this.duplicateUsers.add(userA.email);
          break;
        }
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
